import React from 'react';
import { useBusinessHours } from '../hooks/useBusinessHours';
import { useUser, useRooftop } from '@store';
import { OneOffDaysManager } from '@components/OneOffDays';
import type { Businesshours_Insert_Input } from '@gql/base-types';
import { getRooftopTimezone } from '@utils/timezoneUtils';

interface AddClosureModalProps {
  open: boolean;
  onClose: () => void;
  locationId: string;
}

const AddClosureModal: React.FC<AddClosureModalProps> = ({ open, onClose, locationId }) => {
  const user = useUser();
  const rooftop = useRooftop();
  const { businessHours, createBusinessHours, deleteBusinessHours, creating, deleting } =
    useBusinessHours(locationId);

  const userName = user?.profile?.display_name || 'Unknown';
  const timezone = getRooftopTimezone(rooftop);

  // Wrapper function to adapt to GraphQL mutation signature
  const handleCreate = async (oneOffDays: Businesshours_Insert_Input[]) => {
    await createBusinessHours({ variables: { businessHours: oneOffDays } });
  };

  return (
    <OneOffDaysManager
      config={{
        entityType: 'location',
        entityId: locationId,
        entityName: 'Location',
        timezone: timezone,
        labels: {
          title: 'Manage Location Closures',
          addButtonText: 'ADD A NEW CLOSURE',
          unavailableLabel: 'Closed',
          partialAvailabilityLabel: 'Open From',
          noEntriesText: 'No closures scheduled',
        },
      }}
      oneOffDays={businessHours}
      onCreate={handleCreate}
      onDelete={deleteBusinessHours}
      loading={creating || deleting}
      userName={userName}
      open={open}
      onClose={onClose}
    />
  );
};

export default AddClosureModal;
